import { render, staticRenderFns } from "./field.vue?vue&type=template&id=48355eaf&scoped=true&"
import script from "./field.vue?vue&type=script&lang=js&"
export * from "./field.vue?vue&type=script&lang=js&"
import style0 from "./field.vue?vue&type=style&index=0&id=48355eaf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48355eaf",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VCol,VImg})
